import Typography from '@mui/material/Typography';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';

import { RouteProps } from './type';

const InternalRoute: FC<RouteProps> = ({ children, hash, href, ...props }) => (
  <Typography {...props} component={Link} to={{ hash, pathname: href }}>
    {children}
  </Typography>
);

export default memo(InternalRoute);
